import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { DayOfWeek } from "api/generated/model";
import { GenericMultiCheckboxes } from "org/control/list/controls/common/genericMultiCheckboxes";

type OnChangeCallback = (day: DayOfWeek, value: boolean) => void;

interface CommonProps {
    days: Record<DayOfWeek, boolean[]>;
}
type EditProps = CommonProps & { onChange: OnChangeCallback };
type ReadOnlyProps = CommonProps;
type MultiWeekdayCheckboxesProps =
    | ({ type: "EDIT" } & EditProps)
    | ({ type: "READ_ONLY" } & ReadOnlyProps);

class MultiWeekdayCheckboxes extends React.PureComponent<MultiWeekdayCheckboxesProps> {
    render = () => {
        const labels: Record<DayOfWeek, string> = prepareLabels(
            i18next.language
        );

        switch (this.props.type) {
            case "EDIT": {
                const { days, onChange } = this.props;
                return (
                    <GenericMultiCheckboxes
                        type="EDIT"
                        labels={labels}
                        values={days}
                        onChange={onChange}
                    />
                );
            }
            case "READ_ONLY": {
                const { days } = this.props;
                return (
                    <GenericMultiCheckboxes
                        type="READ_ONLY"
                        labels={labels}
                        values={days}
                    />
                );
            }
            default: {
                return assertNever(this.props);
            }
        }
    };
}

// Pass language (although it's not used explicitly) to ensure memoizeOne resets the cache
// if the language changes.
const prepareLabels = memoizeOne((_language: string) => {
    return {
        Monday: t("Monday"),
        Tuesday: t("Tuesday"),
        Wednesday: t("Wednesday"),
        Thursday: t("Thursday"),
        Friday: t("Friday"),
        Saturday: t("Saturday"),
        Sunday: t("Sunday"),
    };
});

export { MultiWeekdayCheckboxes, type MultiWeekdayCheckboxesProps };
